export const // OLD JOURNAL ORDER
  SPIRIT = 1,
  WRAITH = 2,
  PHANTOM = 3,
  POLTERGEIST = 4,
  BANSHEE = 5,
  JINN = 6,
  MARE = 7,
  REVENANT = 8,
  SHADE = 9,
  DEMON = 10,
  YUREI = 11,
  ONI = 12,
  YOKAI = 13,
  HANTU = 14,
  GORYO = 15,
  MYLING = 16,
  ONRYO = 17,
  THETWINS = 18,
  RAIJU = 19,
  OBAKE = 20,
  THEMIMIC = 21,
  MOROI = 22,
  DEOGEN = 23,
  THAYE = 24,
  // New Ghosts added 16 Dec 2025
  DAYAN = 25,
  GALLU = 26,
  OBAMBO = 27;

export const all_ghosts = [
  // Ordered same as journal page 27
  BANSHEE,
  DAYAN,
  DEOGEN,
  DEMON,
  GALLU,
  GORYO,
  HANTU,
  JINN,
  MARE,
  MOROI,
  MYLING,
  OBAKE,
  OBAMBO,
  ONI,
  ONRYO,
  PHANTOM,
  POLTERGEIST,
  RAIJU,
  REVENANT,
  SHADE,
  SPIRIT,
  THAYE,
  THEMIMIC,
  THETWINS,
  WRAITH,
  YOKAI,
  YUREI,
];
